<template>
  <div class="area-group-dropdown">
    <LineBroadcastDropdown>
      <template v-slot:trigger>
        <div v-if="Array.isArray(selectedAreaTagList) && selectedAreaTagList.length > 0" class="selected-badge-container">
          <LineBroadcastTag v-for="(selectedAreaTag, index) in selectedAreaTagList" :key="index" :tagText="selectedAreaTag" />
        </div>
      </template>
      <template v-slot:panel>
        <div class="target-area-group-panel">
          <LineBroadcastSearchInput @on-change="onSearch" />
          <LineBroadcastCheckbox
            class="header-checkbox"
            :checkState="convertCheckedBooleanToCheckState(isSelectedAll)"
            @on-click="onClickCheckboxAllArea"
          >
            <p>ทั้งหมด</p>
          </LineBroadcastCheckbox>
          <div class="panel-divider" />
          <div class="checkbox-list-container">
            <LineBroadcastCheckbox
              class="header-checkbox"
              v-for="area in areaViewOptionList"
              :key="area.id"
              :checkState="convertCheckedBooleanToCheckState(mapOfAreaIDToSelectionStatus[area.id].isSelected)"
              @on-click="(checkboxState) => onClickCheckboxSingleArea(checkboxState, area.id)"
            >
              <p class="checkbox-label">{{ area.id }} {{ area.areaName }}</p>
            </LineBroadcastCheckbox>
          </div>
        </div>
      </template>
    </LineBroadcastDropdown>
  </div>
</template>
<script>
import LineBroadcastTag from '../../../Tag/Broadcast/Line/LineBroadcastTag.vue';
import LineBroadcastCheckbox from '../../../Checkbox/Broadcast/Line/LineBroadcastCheckbox.vue';
import LineBroadcastDropdown from '../../../Dropdown/Broadcast/Line/LineBroadcastDropdown.vue';
import LineBroadcastSearchInput from '../../../SearchInput/Broadcast/Line/LineBroadcastSearchInput.vue';
/** constants */
import SMM_STATIC_DATA from '../../../../utiles/constants/SMMstaticData';
import CHECK_STATUS_ENUM from '../../../Checkbox/CheckboxStateEnum.json';

export default {
  name: 'AreaGroupDropdown',
  components: {
    LineBroadcastTag,
    LineBroadcastCheckbox,
    LineBroadcastDropdown,
    LineBroadcastSearchInput,
  },
  props: {
    /** Array of selected area's id string that reference to area's code */
    selectedAreaIDList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      allAreaIDList: [],
      isSelectedAll: false,
      /** mapOfAreaIDToSelectionStatus's structure has string of area code as key and value is object of {isSelected: boolean, areaName: string} */
      mapOfAreaIDToSelectionStatus: {},
      /** use for searching area to show only option that contain keyword */
      areaViewOptionList: SMM_STATIC_DATA.AREA_GROUPS,
      localSelectedAreaIDList: this.selectedAreaIDList,
    };
  },
  computed: {
    selectedAreaTagList() {
      return this.convertSelectedAreaToAreaTagList();
    },
  },
  methods: {
    init() {
      /** keep all area code in array of string */
      for (const area of SMM_STATIC_DATA.AREA_GROUPS) {
        this.allAreaIDList.push(area.id);
      }
      /** set all to initial state follow list of area code collect on parent data */
      this.updateCheckboxStateBySelectedAreaIDList(this.localSelectedAreaIDList);
    },
    updateCheckboxStateBySelectedAreaIDList(selectedAreaIDList) {
      const isSelectedAreaIDListValid = Array.isArray(selectedAreaIDList) && selectedAreaIDList.length > 0;
      /** format all for mapOfAreaIDToSelectionStatus */
      for (const areaGroup of SMM_STATIC_DATA.AREA_GROUPS) {
        this.$set(this.mapOfAreaIDToSelectionStatus, areaGroup.id, {
          isSelected: isSelectedAreaIDListValid ? selectedAreaIDList.includes(areaGroup.id) : false,
          areaName: areaGroup.areaName,
        });
      }

      this.isSelectedAll = isSelectedAreaIDListValid && selectedAreaIDList.length === this.allAreaIDList.length;
      this.localSelectedAreaIDList = selectedAreaIDList;
      this.$emit('change', selectedAreaIDList);
    },
    /** convert from isSelected boolean to checkbox state */
    convertCheckedBooleanToCheckState(isChecked) {
      return isChecked ? CHECK_STATUS_ENUM.CHECKED : CHECK_STATUS_ENUM.UNCHECK;
    },
    /** convert to show selected area list to tags in trigger box */
    convertSelectedAreaToAreaTagList() {
      const areaTagList = [];
      for (const selectedAreaID of this.localSelectedAreaIDList) {
        if (this.mapOfAreaIDToSelectionStatus[selectedAreaID].isSelected) {
          areaTagList.push(`${selectedAreaID} ${this.mapOfAreaIDToSelectionStatus[selectedAreaID].areaName}`);
        }
      }
      return areaTagList;
    },
    /** click all area checkbox event effect to change the state of checkbox all area and use utility function updateCheckboxStateBySelectedAreaIDList to handle */
    onClickCheckboxAllArea(checkboxState) {
      const selectedAreaIDList = checkboxState === CHECK_STATUS_ENUM.CHECKED ? this.allAreaIDList : [];
      this.updateCheckboxStateBySelectedAreaIDList(selectedAreaIDList);
    },
    /** click only one area evnet to add or remove the area from selectedAreaIDList on parent and change isSelected boolean on inner state mapOfAreaIDToSelectionStatus */
    onClickCheckboxSingleArea(checkboxState, areaID) {
      /** mutate selected area list on parent */
      if (checkboxState === CHECK_STATUS_ENUM.CHECKED) {
        this.localSelectedAreaIDList.push(areaID);
      } else {
        this.localSelectedAreaIDList = this.localSelectedAreaIDList.filter((selectedAreaID) => selectedAreaID !== areaID);
      }
      this.updateCheckboxStateBySelectedAreaIDList(this.localSelectedAreaIDList);
    },
    onSearch(keyword) {
      /** reset showed area checkbox list to show all when the search input value is empty */
      if (keyword.trim().length < 1) {
        this.areaViewOptionList = SMM_STATIC_DATA.AREA_GROUPS;
        return;
      }

      /** mutate areaViewOptionList to show only member that relate with changed search input keyword */
      const mutatedViewOption = [];
      for (const smmArea of SMM_STATIC_DATA.AREA_GROUPS) {
        const currentAreaViewOption = {
          id: smmArea.id,
          areaName: smmArea.areaName,
        };

        if (currentAreaViewOption.id.includes(keyword) || currentAreaViewOption.areaName.includes(keyword)) {
          mutatedViewOption.push(currentAreaViewOption);
        }
      }
      this.areaViewOptionList = mutatedViewOption;
    },
  },
  beforeMount() {
    /** convert staric data to mapOfAreaIDToSelectionStatus and collect all area's id for compare */
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.area-group-dropdown {
  display: flex;
  flex-direction: column;
  width: 100%;
  p {
    margin-bottom: 0;
  }
  .selected-badge-container {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }
  .target-area-group-panel {
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .panel-divider {
      height: 2px;
      width: 100%;
      background-color: #dadce4;
    }
    .checkbox-list-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .header-checkbox {
      padding-block: 8px;
      vertical-align: middle;
      .checkbox-label {
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: #4b5178;
      }
    }
  }
}
</style>
